module.exports = __webpack_public_path__ + "media/images/flags/1x1/iot-d1e6fb27c626275482557c38ed3ec153.svg";